/* eslint-disable @typescript-eslint/no-explicit-any */
import ENVIRONMENT from '../../environment/environment';

let installed = false;

function getFinderOrigins(): string[] {
  const raw = String(ENVIRONMENT.FILE_MANAGER || '').trim();
  if (!raw) return [];
  try {
    return [new URL(raw.replace(/\/$/, '')).origin];
  } catch {
    return [];
  }
}

/**
 * Nhận file đã chọn từ File Manager popup (cross-origin) và gọi callback CKEditor4.
 */
export function installCKEditorFinderBridge(): void {
  if (installed || typeof window === 'undefined') return;
  installed = true;

  const finderOrigins = getFinderOrigins();

  window.addEventListener('message', (event: MessageEvent) => {
    const data = event.data as Record<string, unknown> | null;
    if (!data || typeof data !== 'object') return;

    const type = data.type;
    if (type && type !== 'CKEDITOR_SELECT_FILE') return;

    if (finderOrigins.length > 0 && !finderOrigins.includes(event.origin)) return;

    const funcNumRaw = data.funcNum ?? data.CKEditorFuncNum;
    const url = data.url;
    if (funcNumRaw == null || funcNumRaw === '' || !url || typeof url !== 'string') return;

    const ck = (window as any).CKEDITOR;
    if (!ck?.tools?.callFunction) return;

    try {
      const funcNum = parseInt(String(funcNumRaw), 10);
      if (Number.isNaN(funcNum)) return;
      ck.tools.callFunction(funcNum, url);
    } catch (err) {
      console.error('[CKEditor] callFunction from File Manager failed', err);
    }
  });
}
